module.exports = __webpack_public_path__ + "static/camera17-0d0cff4dce50db7a7374b5f7610c7dbd.jpg";